export class FileUtil {

  public static splitFileName(fileName : string): { name: string; ext: string; } {
    let resultFileName = '';
    let resultFileExtension = '';

    if (fileName) {
      const lastDot = fileName.lastIndexOf('.');

      if (lastDot !== -1) {
        resultFileName = fileName.substring(0, lastDot);
        resultFileExtension = fileName.substring(lastDot + 1);
      } else {
        resultFileName = fileName;
      }
    }

    return {
      name: resultFileName,
      ext: resultFileExtension,
    };
  }

  public static resourceExists(resourceName : string) : boolean {

    const http = new XMLHttpRequest();
    http.open('HEAD', resourceName, false);
    http.send();
    return http.status !== 404;
  }

  public static splitFileFromPath(filePath : string) : string[] {

    const filePathAdjusted : string = filePath.replaceAll('\\', '/');
    const lastSlashPos = filePathAdjusted.lastIndexOf('/');

    const dirPath = filePathAdjusted.substring(0, lastSlashPos + 1);
    const fileName = filePathAdjusted.substring(lastSlashPos + 1);

    return [dirPath, fileName];
  }

  public static normalize(path : string) : string {
    return path.replaceAll('\\', '/');
  }
}
